import React from "react";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";

const BeaconNetworkCard = ({ card }) => {
  return <CardWrapper {...card} card={card} />;
};

BeaconNetworkCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
};

export default BeaconNetworkCard;
